module.exports = __webpack_public_path__ + "img/verbier-logo.6d0ddac3.png";